import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { MusterAttendanceService } from '../../Model/MusterAttendance/muster-attendance.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';

@Component({
  selector: 'app-designation-summary-form',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, LoaderComponent],
  templateUrl: './designation-summary-form.component.html',
  styleUrl: './designation-summary-form.component.scss'
})
export class DesignationSummaryFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);

  @Input() SiteName: any = null;
  @Input() DesignationSummaryBillingData = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();

  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: false,
    paging: false,
    scrollY: '350px',
    scrollCollapse: true,
    pageLength: 10,
    lengthMenu: [10, 25, 50, 100],
    info: false,
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columnDefs: [
      {
        targets: 0,
        width: '5px',
      },
      {
        targets: 3,
        width: '60px',
      },
      {
        targets: 4,
        width: '60px',
      },
      {
        targets: 5,
        width: '60px',
      },
      {
        targets: 6,
        width: '60px',
      },
      {
        targets: 7,
        width: '60px',
      },
      {
        targets: 8,
        width: '60px',
      },
      {
        targets: 9,
        width: '60px',
      },
      {
        targets: 10,
        width: '60px',
      },
      {
        targets: 11,
        width: '60px',
      },
    ],
    columns: [
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
        },
        orderable: true,
      },
      {
        title: 'Designation',
        data: 'DesignationName',
        orderable: true,
      },
      {
        title: 'Duty',
        data: 'DutyName',
        orderable: true,
      },
      {
        title: 'Total Strength (AsPerContract)',
        data: 'TotalStrengthAsPerContract',
        orderable: true,
        className: 'column-text text-center'
      },
      {
        title: 'ManDays (AsPerContract)',
        data: 'TotalMandaysAsPerContract',
        orderable: true,
        className: 'column-text text-center'
      },
      {
        title: 'Total Strength (AsPerAttendance)',
        data: 'TotalStrengthAsPerAttendance',
        orderable: true,
        className: 'column-text text-center'
      },
      {
        title: 'ManDays (AsPerAttendance)',
        data: 'TotalMandaysAsPerAttendance',
        orderable: true,
        className: 'column-text text-center'
      },
      {
        title: 'Extra Shifts Not Billed',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          const inputId = `extrashiftsnotbilled-input-${meta.row}`;
          return `
            <div class="input-group">
              <input type="number" 
                    class="form-control extrashiftsnotbilled-input" 
                    id="${inputId}"
                    value="${row.ExtraShiftsNotBilled || 0}" 
                    min="-${row.TotalWorkingDays || 0}"
                    max="0"
                    step="0.5"
                    data-row-id="${meta.row}"
                    placeholder="Extra Shift"
                    style="font-size:xx-small">
            </div>
          `;
        },
        orderable: true,
        createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
          const input = $(td).find('.extrashiftsnotbilled-input');

          input.on('change', (event: any) => {
            const value = parseFloat(event.target.value) || 0;
            const isValid = !isNaN(value) && value <= 0 && value >= -rowData.TotalWorkingDays;
            rowData.ExtraShiftsNotBilled = value;
            if (isValid) {
              input.removeClass('is-invalid');
              rowData.ExtraShiftsNotBilledC = value;
              rowData._isInvalid = false;
            } else {
              input.addClass('is-invalid');
              rowData._isInvalid = true;
            }
            // if (value > 0) {
            //   event.target.value = '0';
            //   rowData.ExtraShiftsNotBilled = 0;
            //   rowData.ExtraShiftsNotBilledC = 0;
            // } else if (value < - rowData.TotalWorkingDays) {
            //   rowData.ExtraShiftsNotBilled = 0;
            //   rowData.ExtraShiftsNotBilledC = 0;
            // } else {
            //   rowData.ExtraShiftsNotBilled = value;
            //   rowData.ExtraShiftsNotBilledC = value;
            // }
          });

          input.on('blur', (event: any) => {
            const value = event.target.value;

            if (value === '') {
              input.removeClass('is-invalid');
              rowData.ExtraShiftsNotBilled = 0;
              rowData.ExtraShiftsNotBilledC = 0;
              event.target.value = '0';
            }
            // if (event.target.value === '') {
            //   rowData.ExtraShiftsNotBilled = 0;
            //   rowData.ExtraShiftsNotBilledC = 0;
            // }
          });
        }
      },
      {
        title: 'OT Days',
        data: 'OTDays',
        orderable: true,
        className: 'column-text text-center'
      },
      {
        title: 'Relieving Days',
        data: 'RelievingDays',
        orderable: true,
        className: 'column-text text-center'
      },
      {
        title: 'Total Working days',
        data: 'TotalWorkingDays',
        orderable: true,
        className: 'column-text text-center'
      },
      {
        title: 'Total Leave',
        data: 'TotalLeave',
        orderable: true,
        className: 'column-text text-center'
      },
    ],
  };

  constructor(
    private musterAttendance: MusterAttendanceService,
    private modalService: NgbModal,
    private toast: ToastService,
  ) {
  }

  filter = {
    SelectType: 'UBS',
    ESS_UpdateDailyAttendanceSummaryOAS: [] as any,
  }

  ngOnInit(): void {
    this.initializeDataTable('#designationWiseSummaryEditdata', Object.values(this.DesignationSummaryBillingData));
  }

  ngOnDestroy(): void {
    if ($.fn.dataTable.isDataTable('#designationWiseSummaryEditdata')) {
      $('#designationWiseSummaryEditdata').DataTable().destroy();
    }
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.DesignationSummaryBillingData.filter((row:any) => row._isInvalid).length == 0) {
        this.ESS_UpdateDailyAttendanceSummaryOAS();
      }else{
        this.toast.show({ message: 'Kindly enter 0 or negative values for man days not billed', type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  initializeDataTable(selector: string, data: any[]) {
    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().destroy();
      $(selector).empty();
    }

    const table = $(selector).DataTable({
      data: data,
      ...this.dtOptions
    });
  }

  close(flag = false) {
    this.activeModal.close(flag);
  }

  ESS_UpdateDailyAttendanceSummaryOAS() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to update?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.filter.ESS_UpdateDailyAttendanceSummaryOAS = [];
        this.DesignationSummaryBillingData.filter((e: any) => e.ExtraShiftsNotBilledC != undefined).forEach((element: any) => {
          this.filter.ESS_UpdateDailyAttendanceSummaryOAS.push(
            {
              ESS_DailyAttendanceBillingSummary_OASID: element.ESS_DailyAttendanceBillingSummary_OASID,
              ExtraShiftsNotBilled: element.ExtraShiftsNotBilledC
            }
          );
        });

        this.musterAttendance.ESS_UpdateDailyAttendanceSummaryOAS(this.filter).subscribe({
          next: (response) => {
            if (response.Error_Code == '01') {
              this.filter.ESS_UpdateDailyAttendanceSummaryOAS = [];

              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.close(true);
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }
}
